import axios from "axios";
import { getLocalToken } from "../utilities/authentication";
import config from "../config";

const axiosConfig = {
  timeout: 30000,
  // timeout: 1,
  headers: {
    // "X-API-VERSION": "v1",
    // Authorization: `Bearer ${token}`
  },
};

const rolesAPI = axios.create(axiosConfig);

// Add a request interceptor to grab the latest token on each Ortho API request
// and inject it into the header of the request.
rolesAPI.interceptors.request.use(function (config) {
  let token =
    config.authentationType === "oauth"
      ? getLocalToken("msal.idtoken")
      : getLocalToken("jwt");
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export { rolesAPI };
